import ModuleCreator from "src/store/ModuleCreator";
import InvitationService from "../../services/InvitationService";

export const types = {
	REMOVE:"invitations/remove"
};
export const params = {

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.company,
@property  {array}  modules.companies
 **/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {
		[types.REMOVE] (context, model) {
			return InvitationService.remove(model.uuid).then((response) => {
				context.commit(types.REMOVE, model);
				return response;
			});
		},
	},
	types: types,
};
export default ModuleCreator({ name: "invitation", plural: "invitations" }, InvitationService, module, types, params);
